import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  rootHeader: {},
  rootResults: {},
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  failedRow: {
    backgroundColor: theme.palette.error.light,
  },
  headerCell: {
    backgroundColor: theme.palette.background.dark,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
